export interface WebSocketMessageEvent {
  type?: string;
  message?: unknown;
  reason?: unknown;

  identifier?: string;
  command?: string;
}

export enum WebSocketStatusType {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  WAITING = 'waiting',
}
